module.exports = __webpack_public_path__ + "media/images/illustrations/character-development-01-e4a512c09d3a9c04fd6eea4d89a159dd.svg";